module.exports = __webpack_public_path__ + "static/media/20.41b0fe07.mp3";